export default __webpack_public_path__ + "static/media/courseCatalogB.78b5c3ba.png";